function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect, useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { useTranslation } from 'react-i18next';
import { ContentState, convertToRaw, EditorState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import PropTypes from 'prop-types';
import { wysiwygToolbarOptions } from './utils/wysiwygToolbarOptions';
import HiddenField from './HiddenField';
import '../assets/react-draft-wysiwyg.css';
import '../assets/inputFields.css';
const RichText = props => {
  const {
    t
  } = useTranslation();
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [contentState, setContentState] = useState('');
  useEffect(() => {
    if (props.defaultValue) {
      const contentBlock = htmlToDraft(props.defaultValue);
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      const editorState = EditorState.createWithContent(contentState);
      setEditorState(editorState);
      setContentState(props.defaultValue);
    }
    //eslint-disable-next-line
  }, []);
  const onEditorStateChange = event => {
    setEditorState(event);
    const editorSourceHTML = draftToHtml(convertToRaw(event.getCurrentContent()));
    setContentState(editorSourceHTML);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Editor, _extends({
    wrapperClassName: "wrapper-class",
    editorClassName: "editor-class",
    toolbarClassName: "toolbar-class",
    wrapperStyle: {
      border: '1px solid rgba(0,0,0,0.23)',
      borderRadius: 4,
      padding: '0 8px 8px',
      marginTop: 8,
      marginBottom: 4
    },
    editorStyle: {
      minHeight: 120,
      padding: '0 6px'
    },
    placeholder: `${t('GENERAL.description')}...`,
    editorState: editorState && editorState,
    onEditorStateChange: onEditorStateChange,
    toolbar: wysiwygToolbarOptions
  }, props)), /*#__PURE__*/React.createElement(HiddenField, {
    name: props.name,
    value: contentState
  }));
};
RichText.propTypes = {
  name: PropTypes.string
};
RichText.defaultProps = {
  defaultValue: ''
};
export default RichText;